import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {RepairCentreDto} from "../auto-generated-server-dtos/repair-centre-information/models/repair-centre-dto";
import {environment} from "../../environments/environment";
import {GlobalViewModelDto} from "../auto-generated-server-dtos/global-view-model/repair-centre/global-view-model-dto";

@Injectable({
  providedIn: 'root'
})
export class GetGlobalViewModelService {

  constructor(private httpClient: HttpClient) { }

  getGlobalViewModel() : Observable<GlobalViewModelDto> {
    return this.httpClient.get<GlobalViewModelDto>(`${environment.apiServer}/RepairCentre/GetGlobalViewModel`);
  }
}
